module.exports = __webpack_public_path__ + "img/silver_vip.27172f1f.png";